const indexItems = [
  {
    title: '明星八卦合集',
    desc: '最新明星动态、恋情曝光、家庭风波等热门话题一网打尽',
    count: '328篇',
    icon: 'ri-star-line',
  },
  {
    title: '网红黑料专区',
    desc: '直播网红、短视频达人翻车事件与争议话题深度追踪',
    count: '256篇',
    icon: 'ri-live-line',
  },
  {
    title: '影视综艺吃瓜',
    desc: '热门综艺录制内幕、影视剧拍摄花絮与演员争议全记录',
    count: '215篇',
    icon: 'ri-film-line',
  },
  {
    title: '品牌代言风波',
    desc: '明星代言翻车、品牌紧急公关与解约声明实时跟进',
    count: '187篇',
    icon: 'ri-shopping-bag-line',
  },
  {
    title: '社会热点追踪',
    desc: '与娱乐圈交叉的社会事件、公众人物争议讨论与深度解读',
    count: '162篇',
    icon: 'ri-global-line',
  },
  {
    title: '音乐圈八卦',
    desc: '歌手新专辑争议、演唱会意外与音乐行业最新动态汇总',
    count: '143篇',
    icon: 'ri-music-line',
  },
  {
    title: 'CP绯闻专线',
    desc: '当红CP恋爱实锤、荧幕情侣假戏真做与粉丝反应整理',
    count: '128篇',
    icon: 'ri-heart-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            主题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">51黑料吃瓜网内容分类导航</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer flex items-start gap-3"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}